import { render, staticRenderFns } from "./GlobalConfigCardSurcharge.vue?vue&type=template&id=19dbe74a&scoped=true"
import script from "./GlobalConfigCardSurcharge.vue?vue&type=script&lang=ts"
export * from "./GlobalConfigCardSurcharge.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19dbe74a",
  null
  
)

export default component.exports